let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5dk6T")).then(() => parcelRequire('jC8gw'));